// import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const aiSettingResource = '/admin/settings/ai'

export default {
  getAiSetting() {
    return OperationsRepository.get(`${aiSettingResource}`)
  },
  updateAiSetting(payload) {
    return OperationsRepository.put(`${aiSettingResource}`, payload)
  },
}
